
import FreeFormsEditableFieldName from '@/components/free-forms/editable-fields/name.vue'
import FreeFormsEditableFieldSlug from '@/components/free-forms/editable-fields/slug.vue'
import FreeFormsEditableFieldDescriptionTranslation from '@/components/free-forms/editable-fields/description-translation.vue'
import FreeFormsEditableFieldAccessAllowAfter from '@/components/free-forms/editable-fields/access-allow-after.vue'
import FreeFormsEditableFieldIsFormEnabled from '@/components/free-forms/editable-fields/is-form-enabled.vue'
import FreeFormsEditableFieldAccessDuration from '@/components/free-forms/editable-fields/access-duration.vue'
import FreeFormsOpenDialogFieldPackages from '@/components/free-forms/open-dialog-fields/packages.vue'

import { defineComponent, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useFreeFormsModule } from '@/modules/free-forms'
import { FreeFormsRouteNames } from '@/router/routes-names'
import { usePackageModule } from '@/modules/packages'
import FreeFormsEditableFieldEndDate from '@/components/free-forms/editable-fields/end-date.vue'

export default defineComponent({
    name: 'free-forms-show-edit-free-forms-form',
    components: {
        FreeFormsEditableFieldEndDate,
        FreeFormsEditableFieldName,
        FreeFormsEditableFieldSlug,
        FreeFormsEditableFieldDescriptionTranslation,
        FreeFormsEditableFieldAccessAllowAfter,
        FreeFormsEditableFieldAccessDuration,
        FreeFormsEditableFieldIsFormEnabled,
        FreeFormsOpenDialogFieldPackages
    },
    async setup () {
        const { getFreeForm, freeForm } = useFreeFormsModule()
        const route = useRoute()
        const freeFormModel = ref(freeForm)
        const { getPackages } = usePackageModule()
        await getPackages()

        const shouldShowEndDate = freeFormModel.value?.endDate !== null && freeFormModel.value?.endDate !== undefined
        const shouldShowAccessDuration = freeFormModel.value?.accessDuration !== null && freeFormModel.value?.accessDuration !== undefined

        await getFreeForm(route.params.formId as string)

        return {
            freeFormModel,
            FreeFormsRouteNames,
            shouldShowEndDate,
            shouldShowAccessDuration,
            route
        }
    }
})
